const types = {
  Temp: "°C",
  kWh: "kWh",
  Humidity: "%",
  isOpen: "",
  Light: "lm",
  Motion: "",
  CO2: "ppm",
  water: "",
  SoundPeak: "dB",
  SoundAvg: "dB",
  waterDetectedInt: "",
  cumulative_m3: "m3",
  cumulative_l: "l"
};

import PacketService from "../services/packet-service";
import ApiService from "../services/api-service";
import moment from "moment";
export default {
  parsePacket(device) {
    let displayConfig;
    device.charts = true;

    device.parsedData = {
      output: "offline",
      native: "offline",
      key: ""
    };

    try {
      displayConfig = device.deviceType.niota_maps.display_config;
    } catch (err) {
      device.deviceType = {
        niota_maps: {
          icon_class: "far fa-eye"
        }
      };
      device.charts = false;
      return device;
    }
    //wenn keine pakete dann zurückgeben
    if (!device.packets[0]) {
      device.charts = false;
      return device;
    }

    let parsed = PacketService.getParsed(device.packets[0]);
    let result;
    let multiple = {};
    let units = Object.keys(types);

    if (!parsed) {
      device.parsedData.output = "Synchronisierungsnachricht";
      device.parsedData.native = "Synchronisierungsnachricht";
    }

    try {
      Object.keys(parsed).forEach(function(key) {
        var val = Math.round(parsed[key]);

        if (key === displayConfig.config.key) {
          device.parsedData.key = key;
          result = val;
        }

        if (displayConfig.config.deviceClassName === "elsysThSensor") {
          if (units.indexOf(key) != -1) {
            multiple[key] = "";
            multiple[key] += Math.round(parsed[key]) + " " + types[key];
          }
        }
      });
    } catch (e) {
      device.charts = false;
      return device;
    }

    if (!result) {
      result = 0;
    }

    if (result || result === 0) {
      device.parsedData = {
        output:
          new Intl.NumberFormat("de-DE").format(result) +
          " " +
          displayConfig.config.unit.toString(),
        native: new Intl.NumberFormat("de-DE").format(result),
        //multiple: "",
        key: device.parsedData.key
      };

      if (Object.keys(multiple).length > 0) {
        device.parsedData.output = "";
        let keys = Object.keys(multiple);
        let count = 0;
        keys.forEach(key => {
          device.parsedData.output += multiple[key];
          count++;
          if (keys.length != count) {
            device.parsedData.output += " / ";
          }
        });
      }
    }
    return device;
  },

  detectAlert(device) {
    return this.detectLazyAlerts(device);
  },

  detectLazyAlerts(device) {
    // Hier werden ganz einfache Alarme gesetzt, wenn zB ein Sensor offensichtlich Unsinn liefert
    let displayConfig;
    let hasAlert = null;
    let hour = this.getHours();
    let alert = false;
    let unitValue = null;
    let parked = null;
    device.cssIconClass = "sensor";

    try {
      displayConfig = device.deviceType.niota_maps.display_config;
    } catch (err) {
      return null;
    }
    if (!device.parsedData) {
      hasAlert = false;
      return hasAlert;
    }

    if (!displayConfig) {
      hasAlert = false;
      return hasAlert;
    }

    switch (displayConfig.config.deviceClassName) {
      case "elsysThSensor": //Temperatursensor
        hasAlert = false;
        device.cssIconClass = "temp";
        break;
      case "elsysTHL": //Temperatur, Feuchtigkeits und Licht sensor
        device.cssIconClass = "temp";
        break;
      case "elsysTHCL": //Temperatur, Feuchtigkeits, CO2 und Licht sensor
        if (device.packets[0]) {
          if (typeof device.packets[0].parsed.co2 !== "undefined") {
            unitValue = device.packets[0].parsed.co2;
            if (unitValue > 600) {
              hasAlert = this.createAlert(1, 3, device);
            } else {
              hasAlert = false;
            }
            device.cssIconClass = "co2";
          } else if (typeof device.packets[0].parsed.motion !== "undefined") {
            unitValue = device.packets[0].parsed.motion;
            if (unitValue) {
              alert = true;
              device.parsedData.native = "Bewegung";
              device.parsedData.output = "Bewegung";
            } else {
              device.parsedData.native = "Keine";
              device.parsedData.output = "Keine";
            }
            if (hour >= 18 && alert) {
              hasAlert = this.createAlert(1, 3, device);
            } else {
              hasAlert = false;
            }
            device.cssIconClass = "motion";
          } else {
            device.cssIconClass = "temp";
          }
        }
        break;
      case "elsysERS": //Schallsensor
        var SoundPeak = device.packets[0].parsed.SoundPeak;
        var SoundAvg = device.packets[0].parsed.SoundAvg;
        if (SoundAvg === SoundPeak) {
          hasAlert = this.createAlert(1, 2, device);
          device.parsedData.native = "An";
          device.parsedData.output = "An";
        } else {
          device.parsedData.native = "Aus";
          device.parsedData.output = "Aus";
          hasAlert = false;
        }
        device.cssIconClass = "sound";
        break;
      case "elsysErsTHLM": //Temperatur, Feuchtigkeits, Licht und Bewegungssensor
        if (device.packets[0]) {
          var motion = device.packets[0].parsed.Motion; //Light
          var light = device.packets[0].parsed.Light;
          if (motion || light > 1) {
            alert = true;
            device.parsedData.native = "An";
            device.parsedData.output = "An";
          } else {
            device.parsedData.native = "Aus";
            device.parsedData.output = "Aus";
          }
          if (hour >= 18 && alert) {
            hasAlert = this.createAlert(1, 3, device);
          } else {
            hasAlert = false;
          }
        }
        device.cssIconClass = "light";
        break;
      case "elsysthlm": //Temperatur, Feuchtigkeits und Bewegungssensor
        if (device.packets[0]) {
          unitValue = device.packets[0].parsed.Motion;
          if (unitValue) {
            alert = true;
            device.parsedData.native = "Bewegung";
            device.parsedData.output = "Bewegung";
          } else {
            device.parsedData.native = "Keine";
            device.parsedData.output = "Keine";
          }
          if (hour >= 18 && alert) {
            hasAlert = this.createAlert(1, 3, device);
          } else {
            hasAlert = false;
          }
        }
        device.cssIconClass = "motion";
        break;
      case "adeunisDoorsensor": //Türkontaktsensor
        device.charts = false;
        unitValue = device.packets[0].parsed.isOpen;
        if (unitValue == 1) {
          device.parsedData.output = "Offen";
          hasAlert = this.createAlert(1, 3, device);
        } else {
          device.parsedData.output = "Zu";
          hasAlert = false;
        }
        device.cssIconClass = "door";
        break;
      case "adeunisDoorsensorBrandschott": //Brandschott sensor
        device.charts = false;
        unitValue = device.packets[0].parsed.isOpen;
        if (unitValue == 0) {
          device.parsedData.output = "Offen";
          hasAlert = false;
        } else {
          device.parsedData.output = "Zu";
          hasAlert = this.createAlert(1, 3, device);
        }
        device.cssIconClass = "brandschott";
        break;
      case "adeunisWindowsensor": //Fenster kontaktsensor
        device.charts = false;
        unitValue = device.packets[0].parsed.isOpen;
        if (unitValue == 1) {
          device.parsedData.output = "Offen";
          hasAlert = this.createAlert(1, 3, device);
        } else {
          device.parsedData.output = "Zu";
          hasAlert = false;
        }
        device.cssIconClass = "window";
        break;
      case "ascoelDoorsensor": //Tür kontaktsensor
        device.charts = false;
        device.cssIconClass = "door";
        break;
      case "ascoelWindowsensor": //Fenster kontaktsensor
        device.charts = false;
        device.cssIconClass = "window";
        break;
      case "ascoelDryContact": //tür kontakt
        device.charts = false;
        if (device.eui == "0018B22000002082") {
          //Funktionsfähigkeit Fettabscheider
          var tor1CurrentState = device.packets[0].parsed.tor1CurrentState;
          var tor2CurrentState = device.packets[0].parsed.tor2CurrentState;
          var tor3CurrentState = device.packets[0].parsed.tor3CurrentState;
          var tor4CurrentState = device.packets[0].parsed.tor4CurrentState;
          if (tor1CurrentState == 1) {
            device.parsedData.output = "Nicht OK";
          }
          if (tor2CurrentState == 1) {
            device.parsedData.output = "Nicht OK";
          }
          if (tor3CurrentState == 1) {
            device.parsedData.output = "Nicht OK";
          }
          if (tor4CurrentState == 1) {
            device.parsedData.output = "Nicht OK";
          }
          if (
            !tor2CurrentState &&
            !tor2CurrentState &&
            !tor3CurrentState &&
            !tor4CurrentState
          ) {
            device.parsedData.all = "OK";
            device.parsedData.output = "OK";
            hasAlert = false;
          }
        } else {
          device.parsedData.native === 1
            ? (hasAlert = this.createAlert(1, 3, device))
            : (hasAlert = false);
        }
        device.cssIconClass = "pump";
        break;
      case "pniParksensor": //Parking
        device.charts = false;
        unitValue = device.packets[0].parsed.occupied;
        if (unitValue) {
          device.parsedData.native = "Belegt";
          device.parsedData.output = "Belegt";
          hasAlert = this.createAlert(1, 3, device);
        } else {
          hasAlert = false;
          device.parsedData.native = "Frei";
          device.parsedData.output = "Frei";
        }
        device.cssIconClass = "parking";
        break;
      case "holleymeter": //Stromzähler
        hasAlert = false;
        device.cssIconClass = "kwh";
        break;
      case "dzgDvs74": //Stromzähler
        hasAlert = false;
        device.cssIconClass = "kwh";
        break;
      case "sensingLabWaterLeak": //Feuchtigkeitssensor
        device.charts = false;
        unitValue = device.packets[0].parsed.waterDetectedInt;
        if (unitValue === 1) {
          hasAlert = this.createAlert(1, 3, device);
          device.parsedData.all = "Feucht";
          device.parsedData.output = "Feucht";
        } else {
          device.parsedData.all = "Trocken";
          device.parsedData.output = "Trocken";
          hasAlert = false;
        }
        device.cssIconClass = "pump";
        break;
      case "boschParking": //Parking
        device.charts = false;
        if (device.packets[0]) {
          parked = device.packets[0].parsed.parked;
          if (parked) {
            hasAlert = this.createAlert(1, 3, device);
            device.parsedData.native = "Belegt " + device.title;
            device.parsedData.output = "Belegt";
          } else {
            device.parsedData.native = "Frei " + device.title;
            device.parsedData.output = "Frei";
            hasAlert = false;
          }
        }
        device.cssIconClass = "parking";
        break;
      case "manholeLR": //Manhole
        device.charts = false;
        device.cssIconClass = "manhole";
        break;
      case "shaftmonitor": //Shaft Monitor
        var switch2 = device.packets[0].parsed.switch2;
        var switch1 = device.packets[0].parsed.switch1;
        if (switch2 || switch1) {
          hasAlert = this.createAlert(1, 3, device);
        } else {
          hasAlert = false;
        }
        device.cssIconClass = "shaft";
        break;
      case "itronTemetraWaterMeter": //Wasserzähler
        device.cssIconClass = "pump";
        break;
      case "feedbackTerminal": //feedback terminal
        device.charts = false;
        var parent = this;
        // eslint-disable-next-line no-case-declarations
        let body = {
          limit: 100000,
          from: moment().format("YYYY-MM-DD") + " 00:01:00",
          to: moment().format("YYYY-MM-DD HH:mm:ss")
        };
        if (device.packets[0]) {
          this.getTodaysParsedPackets(device.id, body).then(packets => {
            if (packets) {
              let result = parent.countParseddata(packets);
              var green = result.button_3 ? result.button_3 : 0;
              var orange = result.button_4 ? result.button_4 : 0;
              var red = result.button_5 ? result.button_5 : 0;
              device.parsedData.native =
                "Grün: " + green + ", Orange: " + orange + ", Rot: " + red;
              device.parsedData.output =
                "Grün: " + green + ", Orange: " + orange + ", Rot: " + red;
              if (green >= orange && green >= red) {
                device.deviceType.niota_maps.icon_style = "#28ef00";
                hasAlert = false;
              } else if (orange > green && orange > red) {
                device.deviceType.niota_maps.icon_style = "#FF7F00";
                hasAlert = false;
              } else if (red > green && red > orange) {
                device.deviceType.niota_maps.icon_style = "#f46a6b";
                hasAlert = this.createAlert(1, 3, device);
              }
            }
          });
        }
        device.cssIconClass = "smile";
        break;
      case "itronAquadis":
        hasAlert = false;
        device.cssIconClass = "water";
        // device.parsedData.native =
        //   new Intl.NumberFormat("de-DE").format(
        //     device.packets[0].parsed.cumulative_l
        //   ) + " m3";
        // device.parsedData.output =
        //   new Intl.NumberFormat("de-DE").format(
        //     device.packets[0].parsed.cumulative_l
        //   ) + " m3";
        break;
      default:
        hasAlert = null;
    }
    return hasAlert;
  },

  createAlert(alertType, alertDelivery, device = null) {
    let message;
    let delivery;
    /*switch (alertType) {
      case 1:
        message = `Alarm`;
        break;
      default:
        message = `Ich habe einen Alarm ausgelöst`;
    }*/

    switch (alertDelivery) {
      case 1:
        delivery = "Der DIGIMONDO Support wurde per Email benachrichtigt.";
        break;
      case 2:
        delivery = "";
        break;
      case 3:
        delivery = "";
        break;
      default:
        // delivery = "Das Hausmeister-Team ist informiert."
        delivery = "";
    }
    return {
      message: message,
      delivery: delivery,
      location: device ? device.description : ""
    };
  },

  buildTileObject(context, devices) {
    context.$loader.startLoading("getApplicationDevices");
    /*const units = {
      Temp: "Temperatursensoren",
      kWh: "Stromerfassung",
      Humidity: "Feuchtigkeitssensoren",
      isOpen: "Tür/Fensterkontakt",
      Light: "Lichtsensoren",
      Motion: "Technikräume",
      CO2: "CO2 Sensoren",
      SoundAvg: "Notstromversorgung",
      waterDetectedInt: "Pumpe"
    };*/

    const dtarrayCustomSort = [
      "Strom- und Wasserzähler",
      "Unerwünschter Aufenthalt",
      "Pumpe",
      "Technikräume",
      "Tür/Fensterkontakt",
      "Notstromversorgung",
      "Büro",
      "Brandschotts",
      "Stellplatzbelegung",
      "Kunden-Feedback",
      "Mobile Geräte"
    ];

    let dtarray = [];
    let obarray = [];
    let filter = [];

    /*devices.forEach(device => { //by units
      if (device.packets[0] && device.packets[0].parsed) {
        var keys = Object.keys(device.packets[0].parsed);
        keys.forEach(type => {
          var typesKeys = Object.keys(units);
          var index = typesKeys.indexOf(type);
          if (index !== -1) {
            return dtarray.indexOf(type) === -1 ? dtarray.push(type) : null;
          }
        });
      }
    });*/

    /*devices.forEach(device => { by deviceType description
      if (device.deviceType.description) {
        return dtarray.indexOf(device.deviceType.description) === -1
          ? dtarray.push(device.deviceType.description)
          : null;
      }
    });*/
    if (Array.isArray(devices)) {
      devices.forEach(device => {
        //by device tile_name
        if (device.tile_name) {
          return dtarray.indexOf(device.tile_name) === -1
            ? dtarray.push(device.tile_name)
            : null;
        }
      });
    }

    /*dtarray.forEach(dt => {
      let tileDevices = []; // clear it every time
      let hasAlert = false;
      Object.keys(devices).forEach(function(key) {
        if (devices[key].packets[0] && devices[key].packets[0].parsed) {
          var parsedTypes = Object.keys(devices[key].packets[0].parsed);
          parsedTypes.forEach(parsedType => {
            if (parsedType === dt) {
              tileDevices.push(devices[key]);
              if (
                !hasAlert &&
                devices[key].hasAlert &&
                devices[key].parsedData.key == dt
              ) {
                hasAlert = true;
              }
            }
          });
        }
      });
      let tooltip =
        `Hier klicken um die ${units[dt]} auf der Karte anzuzeigen!`;
      obarray.push({
        tileId: dt,
        hasAlert: hasAlert,
        tileData: tileDevices,
        tooltip: tooltip,
        tileTitle: units[dt]
      });
    });*/

    //Old function

    /*dtarray.forEach(dt => {
      let tileDevices = []; // clear it every time
      let hasAlert = false;
      Object.keys(devices).forEach(function(key) {
        if (typeof devices[key].deviceType.description !== 'undefined') {
          if (devices[key].deviceType.description === dt) {
            tileDevices.push(devices[key]);
            if (!hasAlert && devices[key].hasAlert) {
              hasAlert = true;
            }
          }
        }
      });
      let tooltip = "Hier finden Sie  alle Infos zu den Kontrollsystemen - " + dt
      obarray.push({ tileId: dt, hasAlert: hasAlert, tileData: tileDevices, tooltip: tooltip });
    });*/

    dtarrayCustomSort.forEach(dt => {
      let tileDevices = []; // clear it every time
      let hasAlert = false;
      Object.keys(devices).forEach(function(key) {
        if (typeof devices[key].tile_name !== undefined) {
          if (devices[key].tile_name === dt) {
            tileDevices.push(devices[key]);
            devices[key].groupName = dt;
            var result = filter.filter(element => element.text === dt);
            if (result.length === 0) {
              filter.push({ text: dt, value: dt });
            }
            if (!hasAlert && devices[key].hasAlert) {
              hasAlert = true;
            }
          }
        }
      });
      if (tileDevices.length) {
        obarray.push({
          tileId: dt,
          hasAlert: hasAlert,
          tileData: tileDevices
          //tooltip: tooltip
        });
      }
    });

    /*dtarray.forEach(dt => {
      let tileDevices = []; // clear it every time
      let hasAlert = false;
      Object.keys(devices).forEach(function(key) {
        if (typeof devices[key].deviceType.description !== "undefined") {
          if (devices[key].deviceType.description === dt) {
            tileDevices.push(devices[key]);
            devices[key].groupName = dt;
            var result = typeFilter.filter(element => element.text === dt);
            if (result.length === 0) {
              typeFilter.push({ text: dt, value: dt });
            }
            if (!hasAlert && devices[key].hasAlert) {
              hasAlert = true;
            }
          }
        }
      });
      let tooltip =
        "Hier finden Sie alle Infos zu den Kontrollsystemen - " + dt;
      obarray.push({
        tileId: dt,
        hasAlert: hasAlert,
        tileData: tileDevices,
        tooltip: tooltip
      });
    });*/

    context.$loader.endLoading("getApplicationDevices");
    return { tilesTable: obarray, filter: filter };
  },

  getHours() {
    //DE Timezone
    var options = {
      timeZone: "Europe/Berlin",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    };

    var formatter = new Intl.DateTimeFormat([], options);
    var currentTime = formatter.format(new Date());
    var hour = new Date(currentTime).getHours();
    //var time = Date.now();
    //var actualTime = Math.floor(time/1000);

    return hour;
  },

  getTodaysParsedPackets(deviceId, body) {
    return ApiService.getParsedPackets(deviceId, body)
      .then(response => {
        return response;
      })
      .catch(() => {
        return false;
      });
  },

  countParseddata(data) {
    const fbUnits = ["button_3", "button_4", "button_5"];
    let keys = Object.keys(data);
    let result = {};
    keys.forEach(key => {
      if (fbUnits.indexOf(key) !== -1) {
        let firstItem = data[key][data[key].length - 1];
        let lastItem = data[key][0];
        let diff =
          parseInt(lastItem.orig_value) - parseInt(firstItem.orig_value);
        result[key] = diff;
      }
    });
    return result;
  }
};
